module.exports = __webpack_public_path__ + "img/q1.dd20f192.png";